import {List, ListItem} from '@material-ui/core';
import CustomChip from '../../../common/CustomChip/CustomChip';
import {
    selectMedicLanguages,
    selectNewMedicLanguages,
    setNewMedicLanguages
} from "../../../../store/medicProfileSlice";
import {useAppDispatch, useAppSelector} from "../../../../hooks/customReduxHooks";
import {isNotNull} from "../../../../utils/lang";
import useStyles from './AddedLanguagesStyles';
import {LanguageDto} from "../../../../types/language";

const AddedLanguages = () => {
    const classes = useStyles();
    const dispatch = useAppDispatch();

    const medicLanguages = useAppSelector(selectMedicLanguages);
    const newMedicLanguages = useAppSelector(selectNewMedicLanguages);

    const langListItems = isNotNull(newMedicLanguages)
        ? newMedicLanguages
        : medicLanguages;

    const deleteLanguageClickHandler = (lang: LanguageDto) => {
        const newMedicLangsUpdate = [...langListItems];
        const tagIndex = langListItems.indexOf(lang);
        newMedicLangsUpdate.splice(tagIndex, 1);
        dispatch(
            setNewMedicLanguages(newMedicLangsUpdate)
        );
    }

    return (
        <List
            className={classes.list}
            disablePadding={true}
        >
            {
                langListItems?.map(lang => (
                    <ListItem
                        className={classes.listItem}
                        key={lang.id}
                        disableGutters={true}
                    >
                        <CustomChip
                            label={lang.code}
                            onDelete={() => deleteLanguageClickHandler(lang)}
                        />
                    </ListItem>
                ))
            }
        </List>
    )
}

export default AddedLanguages;
